import DocumentPreviewDialog, {
  DocumentPreviewDialogProps,
} from '~/components/invoices/PreviewInvoice/DocumentPreviewDialog';
import { useModal } from '~/modals/Modal';
import { AnalyticsEvents } from '~/services/analytics';
import { useAnalytics } from './useAnalytics';

export function useInvoicePreviewModal() {
  const { showModal } = useModal();
  const { track } = useAnalytics();

  return (props: Omit<DocumentPreviewDialogProps, 'closeModal'>) => {
    track(AnalyticsEvents.INVOICE_VIEWED);
    showModal({
      component: DocumentPreviewDialog,
      props,
    });
  };
}
